import React from 'react';
import T from 'prop-types';
import { Button, Modal } from 'antd';

import ErrorAlert from '../../../errorAlert';

import { StyledCard } from './style';

const ResetPasswordCard = ({ email, error, errorMessage, loading, requestPasswordReset }) => {
  const handleOnOk = () => {
    requestPasswordReset({ email });
  };

  const confirm = () => {
    Modal.confirm({
      title: 'Confirm Password Reset',
      content: 'A password reset link will be sent to your email.',
      okText: 'Reset Password',
      okButtonProps: { type: 'primary' },
      cancelText: 'Cancel',
      onOk: handleOnOk,
    });
  };

  return (
    <StyledCard bordered={false} title="Reset Password">
      <ErrorAlert message={errorMessage} visible={error} />
      <Button loading={loading} onClick={confirm} type="primary">
        Reset Password
      </Button>
    </StyledCard>
  );
};

ResetPasswordCard.propTypes = {
  requestPasswordReset: T.func.isRequired,

  email: T.string.isRequired,
  loading: T.bool.isRequired,
  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
};

export default ResetPasswordCard;
